import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiCardActions = {
	styleOverrides: {
		root: ({ theme }) => ({
			padding: theme.spacing(1, 2, 2),
			[theme.breakpoints.up("sm")]: {
				padding: theme.spacing(1, 3, 2.5),
			},
		}),
	},
} satisfies Components<Theme>["MuiCardActions"];
